import React from 'react'
import { Route, Redirect } from 'react-router-dom'
import { connect } from 'react-redux'
import {isInitedSelector} from '../../modules/app'
import {isAuthSelector} from '../../modules/profile'
import {routesUrls} from '../../settings/routes'

const NotAuthRoute = ({ isInited, isAuth, component: Component, ...rest }) => {
    if (!isInited) return <Route {...rest} render={props => (<Component {...props} />)} />

    return (
        <Route {...rest} render={props => (
            ( !isAuth ) ? (
                <Component {...props}/>
            ) : (
                <Redirect to={{
                    pathname: routesUrls.dashboard,
                    state: { from: props.location }
                }}/>
            )
        )}/>
    )
}

export default connect(
    state=>({
        isInited : isInitedSelector(state),
        isAuth : isAuthSelector(state),
    }),
    null,
    null,
    {pure:false}
)(NotAuthRoute)


// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/routes/NotAuthRoute.js